var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.75,
    height: 18,
    viewBox: "0 0 22.75 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(-645 -350)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 14,
    transform: "translate(653 352)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 14,
    transform: "translate(653 359)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 14,
    transform: "translate(653 366)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(645 350)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(645 357)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(645 364)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/order-list.5fb84f74d9d457f42b7038e75e8951a3.svg";
export { ForwardRef as ReactComponent };